import type { SourceType } from '@ardoq/api-types/integrations';
import { mapValues } from 'lodash';
import {
  ardoqUrl,
  awsUrl,
  azureUrl,
  celonisUrl,
  excelUrl,
  importBuilderUrl,
  itPediaUrl,
  jiraUrl,
  jsonUrl,
  microsoftEntraIdUrl,
  publicApiUrl,
  servicenowUrl,
  sharepointUrl,
  signavioExporterUrl,
  signavioUrl,
  symbioExportUrl,
  symbioUrl,
} from './logos';

type IntegrationSource = {
  name: string;
  logoUrl: string;
};

export const integrationSources: Record<SourceType, IntegrationSource> = {
  servicenow: {
    name: 'ServiceNow',
    logoUrl: servicenowUrl,
  },
  'servicenow-guided-exporter': {
    name: 'ServiceNow Exporter',
    logoUrl: servicenowUrl,
  },
  'servicenow-export': {
    name: 'ServiceNow Exporter',
    logoUrl: servicenowUrl,
  },
  'jira-software': {
    name: 'Jira Software Cloud',
    logoUrl: jiraUrl,
  },
  microsoftgraph: {
    name: 'Microsoft Entra ID',
    logoUrl: microsoftEntraIdUrl,
  },
  'entra-id': {
    name: 'Microsoft Entra ID',
    logoUrl: microsoftEntraIdUrl,
  },
  azure: {
    name: 'Azure',
    logoUrl: azureUrl,
  },
  'azure-resources': {
    name: 'Azure Resources',
    logoUrl: azureUrl,
  },
  aws: {
    name: 'AWS',
    logoUrl: awsUrl,
  },
  itpedia: {
    name: 'IT-Pedia',
    logoUrl: itPediaUrl,
  },
  signavio: {
    name: 'SAP Signavio Importer',
    logoUrl: signavioUrl,
  },
  'signavio-exporter': {
    name: 'SAP Signavio Exporter',
    logoUrl: signavioExporterUrl,
  },
  celonis: {
    name: 'Celonis Process Intelligence',
    logoUrl: celonisUrl,
  },
  symbio: {
    name: 'Celonis Process Management Importer',
    logoUrl: symbioUrl,
  },
  'celonis-exporter': {
    name: 'Celonis Process Management Exporter',
    logoUrl: symbioExportUrl,
  },
  ardoq: {
    name: 'Ardoq Importer',
    logoUrl: ardoqUrl,
  },
  'ardoq-sample-data': {
    name: 'Ardoq Sample Data Importer',
    logoUrl: ardoqUrl,
  },
  'ardoq-reference-data': {
    name: 'Ardoq Reference Data Importer',
    logoUrl: ardoqUrl,
  },
  'sharepoint-files': {
    name: 'SharePoint',
    logoUrl: sharepointUrl,
  },
  sheets: {
    name: 'Excel',
    logoUrl: excelUrl,
  },
  excel: {
    name: 'Excel',
    logoUrl: excelUrl,
  },
  csv: {
    name: 'Excel',
    logoUrl: excelUrl,
  },
  json: {
    name: 'JSON',
    logoUrl: jsonUrl,
  },
  'import-builder': {
    name: 'Import Builder',
    logoUrl: importBuilderUrl,
  },
  'import-api': {
    name: 'Import API',
    logoUrl: publicApiUrl,
  },
};

export const isIntegrationProvenanceSource = (
  source: string
): source is SourceType => Object.hasOwn(integrationSources, source);

export const integrationNames: Record<SourceType, string> = mapValues(
  integrationSources,
  ({ name }) => name
);
